import { render, staticRenderFns } from "./ListaFornecedores.vue?vue&type=template&id=eb91a564&"
import script from "./ListaFornecedores.vue?vue&type=script&lang=js&"
export * from "./ListaFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports